<template>
  <Line :chartData="chartData" :chartOptions="chartOptions" />
</template>

<script setup>
import { Line } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  Filler,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale,
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  Filler,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale
)

// eslint-disable-next-line
const props = defineProps({
  chartData: {
    type: Object,
    default() {
      return {
        labels: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
        ],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: '#00D8FF',
            fill: true,
            tension: 0.4,
            data: [40, 39, 10, 40, 39, 80, 40],
          },
          {
            label: 'Data Two',
            backgroundColor: '#E46651',
            fill: true,
            tension: 0.4,
            data: [60, 55, 32, 10, 2, 12, 53],
          },
        ],
      }
    },
  },
  chartOptions: {
    type: Object,
    default() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'top',
            align: 'end',
            onClick(e, legendItem, legend) {
              const index = legendItem.datasetIndex
              const ci = legend.chart
              if (ci.isDatasetVisible(index)) {
                ci.hide(index)
                legendItem.hidden = true
              } else {
                ci.show(index)
                legendItem.hidden = false
              }
            },
            labels: {
              color: '#fff',
              boxWidth: 12,
              boxHeight: 12,
              font: {
                size: 16,
              },
              generateLabels(chart) {
                const datasets = chart.data.datasets
                const {
                  labels: { usePointStyle, pointStyle, textAlign, color },
                } = chart.legend.options

                return chart._getSortedDatasetMetas().map((meta) => {
                  const style = meta.controller.getStyle(
                    usePointStyle ? 0 : undefined
                  )

                  return {
                    text: datasets[meta.index].label,
                    fillStyle: style.borderColor || style.backgroundColor,
                    fontColor: color,
                    hidden: !meta.visible,
                    lineCap: style.borderCapStyle,
                    lineDash: style.borderDash,
                    lineDashOffset: style.borderDashOffset,
                    lineJoin: style.borderJoinStyle,
                    lineWidth: 0,
                    strokeStyle: style.borderColor,
                    pointStyle: pointStyle || style.pointStyle,
                    rotation: style.rotation,
                    textAlign: textAlign || style.textAlign,
                    borderRadius: 0,
                    datasetIndex: meta.index,
                  }
                }, this)
              },
            },
          },
        },
        scales: {
          x: {
            grid: {
              borderColor: '#777',
              color: false,
            },
            ticks: {
              color: '#fff',
            },
          },
          y: {
            grid: {
              borderColor: '#777',
              color: false,
            },
            ticks: {
              color: '#fff',
            },
          },
        },
      }
    },
  },
})
</script>

<style scoped lang="scss"></style>
